import { Fragment, useMemo } from 'react';
import AppTable from '../../../../constants/AppTable';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { useDispatch } from 'react-redux';
import { SALES_DELETE_PRODUCT_ITEM } from '../../../../store/inventorySlice';
import { SalesProductListReducer } from '../../../../helpers/models/Models';

const ProductSaleListView = () => {
  const dispatch = useDispatch();
  const { SalesProductList } = useSelector((state: RootState) => state.inventory);
  const columns = useMemo(() => [
    { header: 'SN', accessor: 'sn', sortable: false },
    { header: 'Store Name', accessor: 'store', sortable: true },
    { header: 'Product', accessor: 'pro_name', sortable: false },
    { header: 'Issue Date', accessor: 'pur_sale_date', sortable: false },
    { header: 'Member SN', accessor: 'member_sn', sortable: false },
    { header: 'Sales Quantity', accessor: 'sales_qty', sortable: false },
    { header: 'Total Amount', accessor: 'tot_amt', sortable: false },
    { header: 'Actions', accessor: 'actions', action: true },
  ], []);

  const modifiedData: SalesProductListReducer[] = useMemo(() => {
    if (!SalesProductList) return [];
    return SalesProductList.map((item, index) => ({
      ...item,
      sn: index + 1,
    }));
  }, [SalesProductList]);

  const handleDelete = (items: SalesProductListReducer) => {
    dispatch(SALES_DELETE_PRODUCT_ITEM(items.product));
  };

  return (
    <Fragment>
      <AppTable
        columns={columns}
        data={modifiedData}
        onDelete={handleDelete}
      />
    </Fragment>
  );
}

export default ProductSaleListView